import React from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';

// v5 -> v6 shim. Existing code uses:
//   props.history.push(path) / replace(path) / goBack()
//   props.match.params.<X>
//   props.location.<pathname|search|hash|state>
// Wrap class components with this so the v5 API keeps working under v6.
export function withRouter(Component) {
    return function ComponentWithRouterProp(props) {
        const navigate = useNavigate();
        const params = useParams();
        const location = useLocation();
        const history = {
            push: (to, state) => navigate(to, { state }),
            replace: (to, state) => navigate(to, { replace: true, state }),
            goBack: () => navigate(-1),
            go: (n) => navigate(n),
            location,
        };
        return (
            <Component
                {...props}
                history={history}
                match={{ params }}
                location={location}
                navigate={navigate}
            />
        );
    };
}

export default withRouter;
